"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImDateFormatter = void 0;
const constant_provider_1 = require("./../cultures/providers/constant-provider");
class ImDateFormatter {
    constructor(locale) {
        this._dayNames = constant_provider_1.ConstantProvider.getDayNames(locale);
        this._monthNames = constant_provider_1.ConstantProvider.getMonthNames(locale);
        this._monthShortNames = constant_provider_1.ConstantProvider.getMonthShortNames(locale);
    }
    format(date, dateFormat) {
        if (isNaN(date.getTime()))
            return '';
        date = this.getIsoDate(date);
        let formattedDate = dateFormat;
        let replaceValues = {};
        if (formattedDate.includes('ddd')) {
            const formatDay = this.getDay(date, formattedDate);
            formattedDate = formattedDate.replace(formatDay.format, '<WEEKDAY>');
            replaceValues['<WEEKDAY>'] = formatDay.value;
        }
        if (formattedDate.includes('M')) {
            const formatMonth = this.getMonth(date, formattedDate);
            formattedDate = formattedDate.replace(formatMonth.format, '<MON>');
            replaceValues['<MON>'] = formatMonth.value;
        }
        if (formattedDate.includes('yy')) {
            const formatYear = this.getYear(date, formattedDate);
            formattedDate = formattedDate.replace(formatYear.format, formatYear.value);
        }
        if (formattedDate.includes('d')) {
            const formatDate = this.getDate(date, formattedDate);
            formattedDate = formattedDate.replace(formatDate.format, formatDate.value);
        }
        if (formattedDate.includes('h') || formattedDate.includes('H')) {
            const formatDate = this.getHours(date, formattedDate);
            formattedDate = formattedDate.replace(formatDate.format, formatDate.value);
        }
        if (formattedDate.includes('m')) {
            const formatDate = this.getMinutes(date, formattedDate);
            formattedDate = formattedDate.replace(formatDate.format, formatDate.value);
        }
        if (formattedDate.includes('s')) {
            const formatDate = this.getSeconds(date, formattedDate);
            formattedDate = formattedDate.replace(formatDate.format, formatDate.value);
        }
        if (formattedDate.includes('tt')) {
            const formatDate = this.getAmPm(date);
            formattedDate = formattedDate.replace(formatDate.format, formatDate.value);
        }
        for (const prop in replaceValues) {
            formattedDate = formattedDate.replace(prop, replaceValues[prop]);
        }
        return formattedDate;
    }
    getDate(date, dateFormat) {
        let strDate = date.getDate().toString();
        let format = dateFormat.includes('dd') ? 'dd' : 'd';
        if (strDate.length == 1 && format.length == 2) {
            strDate = '0' + strDate;
        }
        return { format: format, value: strDate };
    }
    getMonth(date, dateFormat) {
        var _a;
        const month = date.getMonth();
        let strMonth = (month + 1).toString();
        let format = 'M';
        if (dateFormat.includes('MMMM')) {
            format = 'MMMM';
            strMonth = this._monthNames[month];
        }
        else if (dateFormat.includes('MMM')) {
            format = 'MMM';
            strMonth = (_a = this._monthShortNames[month]) !== null && _a !== void 0 ? _a : this._monthNames[month].substring(0, 3);
        }
        else if (dateFormat.includes('MM')) {
            format = 'MM';
            if (strMonth.length == 1)
                strMonth = '0' + strMonth;
        }
        return { format: format, value: strMonth };
    }
    getYear(date, dateFormat) {
        let strYear = date.getFullYear().toString();
        let format = 'yy';
        if (dateFormat.includes('yyyy')) {
            format = 'yyyy';
        }
        else {
            strYear = strYear.slice(-2);
        }
        return { format: format, value: strYear };
    }
    getDay(date, dateFormat) {
        let dayName = this._dayNames[date.getDay()];
        const format = dateFormat.includes('dddd') ? 'dddd' : 'ddd';
        if (format === 'ddd')
            dayName = dayName.substring(0, 3);
        return { format: format, value: dayName };
    }
    getHours(date, dateFormat) {
        const hours = date.getHours();
        let strHours = hours.toString();
        let format = dateFormat.includes('hh') ? 'hh' : 'h';
        if (dateFormat.includes('H')) {
            format = dateFormat.includes('HH') ? 'HH' : 'H';
        }
        else {
            strHours = ((hours % 12) || 12).toString();
        }
        if (strHours.length == 1 && format.length == 2) {
            strHours = '0' + strHours;
        }
        return { format: format, value: strHours };
    }
    getMinutes(date, dateFormat) {
        let strMinutes = date.getMinutes().toString();
        let format = dateFormat.includes('mm') ? 'mm' : 'm';
        if (strMinutes.length == 1 && format.length == 2) {
            strMinutes = '0' + strMinutes;
        }
        return { format: format, value: strMinutes };
    }
    getSeconds(date, dateFormat) {
        let strSeconds = date.getSeconds().toString();
        let format = dateFormat.includes('ss') ? 'ss' : 's';
        if (strSeconds.length == 1 && format.length == 2) {
            strSeconds = '0' + strSeconds;
        }
        return { format: format, value: strSeconds };
    }
    getAmPm(date) {
        let hours = date.getHours();
        let am_pm = hours >= 12 ? 'pm' : 'am';
        return { format: 'tt', value: am_pm };
    }
    getIsoDate(date) {
        if (date.getTimezoneOffset() > 0 && date.toISOString().includes('T00:00:00.000Z')) {
            date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        }
        return date;
    }
}
exports.ImDateFormatter = ImDateFormatter;
